import { RootState } from "@modules/store/redux/rootReducer"

export const temporaryPasswordSelector = (state: RootState) =>
  state.userProfile.user.data?.temporaryPassword
